import { useNavigate } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

// Card cu lacăt pentru funcțiile Premium — le arătăm, nu le ascundem.
export function PremiumLock({ title, desc, testid }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={testid}
      className="rounded-2xl border border-dashed border-amber-300 bg-amber-50 p-4 text-center"
    >
      <div className="flex items-center justify-center gap-2 text-amber-700 font-semibold">
        <Lock className="h-4 w-4" strokeWidth={2.5} />
        {title}
      </div>
      <p className="text-sm text-amber-700/80 mt-1">{desc}</p>
      <button
        data-testid={testid ? `${testid}-cta` : undefined}
        onClick={() => navigate("/premium")}
        className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold transition-colors"
      >
        <Crown className="h-4 w-4" strokeWidth={2.5} />
        Vezi Chit Premium
      </button>
    </div>
  );
}
